(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["custom-image-split-section"] && !Shopify.designMode) return;
  try {
    
document.addEventListener("DOMContentLoaded", function () {

  var isSplitSliderInitialized = false;

  function initSplitSlider() {

    if (
      window.innerWidth <= 767 &&
      !isSplitSliderInitialized &&
      typeof jQuery !== 'undefined'
    ) {

      $('.custom-split--slick-slider').slick({
        centerMode: true,
        centerPadding: '0',
        slidesToShow: 1,
        arrows: false,
        dots: false,
        infinite: true
      });

      // custom arrows
      $('.custom-prev-mobile').off('click').on('click', function () {
        $('.custom-split--slick-slider').slick('slickPrev');
      });

      $('.custom-next-mobile').off('click').on('click', function () {
        $('.custom-split--slick-slider').slick('slickNext');
      });

      isSplitSliderInitialized = true;
    }
  }

  function destroySplitSlider() {

    if (
      window.innerWidth > 767 &&
      isSplitSliderInitialized &&
      typeof jQuery !== 'undefined'
    ) {

      $('.custom-split--slick-slider').slick('unslick');

      isSplitSliderInitialized = false;
    }
  }

  initSplitSlider();

  var resizeTimeout;

  window.addEventListener('resize', function () {

    clearTimeout(resizeTimeout);

    resizeTimeout = setTimeout(function () {

      initSplitSlider();
      destroySplitSlider();

    }, 200);

  });

});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["cyber-accordion-part-section"] && !Shopify.designMode) return;
  try {
    
document.addEventListener("DOMContentLoaded", function () {
  const accordionItems = document.querySelectorAll('.custom-accordion-wrapper .accordion-item');

  // Ensure only the first item is active initially
  accordionItems.forEach(function (item, index) {
    const content = item.querySelector('.accordion-content');
    if (index === 0) {
      item.classList.add('active');
      content.style.display = 'block';
    } else {
      item.classList.remove('active');
      content.style.display = 'none';
    }
  });

  // Click event to toggle accordion
  document.querySelectorAll('.accordion-title').forEach(function (title) {
    title.addEventListener('click', function () {
      const currentItem = this.parentElement;
      const currentContent = currentItem.querySelector('.accordion-content');
      const isActive = currentItem.classList.contains('active');

      // Close all items
      accordionItems.forEach(function (item) {
        item.classList.remove('active');
        item.querySelector('.accordion-content').style.display = 'none';
      });

      // Toggle current item only if it wasn't already active
      if (!isActive) {
        currentItem.classList.add('active');
        currentContent.style.display = 'block';
      }
    });
  });
});


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["cyber-custom-slider-section"] && !Shopify.designMode) return;
  try {
    
$(document).ready(function () {
  $('.cyber-new-custom-slider').slick({
    infinite: true,
    slidesToShow: 1,
    slidesToScroll: 1,
    arrows: true,
    centerMode: true,
    centerPadding: '0%',
    prevArrow: $('.custom-prev'),
    nextArrow: $('.custom-next')
  });

  $('.cyber-new-custom-slider-mobile').slick({
    infinite: true,
    slidesToShow: 1,
    slidesToScroll: 1,
    arrows: true,
    centerMode: false,
    prevArrow: $('.custom-prev-mobile'),
    nextArrow: $('.custom-next-mobile')
  });
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["cyber-image-overlay-split-single-overlay"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener("DOMContentLoaded", function () {
    var isMobileSliderInitialized = false;

    function initMobileSlider() {
      if (window.innerWidth <= 767 && !isMobileSliderInitialized && typeof jQuery !== 'undefined') {
        $('.slider-mobile-only').slick({
          arrows: false,
          dots: true,
          infinite: true,
          slidesToShow: 1,
          slidesToScroll: 1
        });
        isMobileSliderInitialized = true;
      }
    }

    function destroyMobileSlider() {
      if (window.innerWidth > 767 && isMobileSliderInitialized && typeof jQuery !== 'undefined') {
        $('.slider-mobile-only').slick('unslick');
        isMobileSliderInitialized = false;
      }
    }

    // Initial check
    initMobileSlider();

    // On resize, debounce to avoid performance issues
    var resizeTimeout;
    window.addEventListener('resize', function () {
      clearTimeout(resizeTimeout);
      resizeTimeout = setTimeout(function () {
        initMobileSlider();
        destroyMobileSlider();
      }, 200);
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["cyber-two-part-accordion"] && !Shopify.designMode) return;
  try {
    
document.addEventListener('DOMContentLoaded', function () {
  const section = document.querySelector('.cyber-custom-two-part-accordion-section');
  if (!section) return;

  const accordionItems = section.querySelectorAll('.cyber-accordion-item');

  // Set initial visibility
  accordionItems.forEach(function (item) {
    const content = item.querySelector('.cyber-accordion-content');
    content.style.display = item.classList.contains('active') ? 'block' : 'none';
  });

  section.querySelectorAll('.cyber-accordion-title').forEach(function (title) {
    title.addEventListener('click', function () {
      const currentItem = this.parentElement;
      const currentContent = currentItem.querySelector('.cyber-accordion-content');
      const isActive = currentItem.classList.contains('active');

      // Close all
      accordionItems.forEach(function (item) {
        item.classList.remove('active');
        item.querySelector('.cyber-accordion-content').style.display = 'none';
      });

      // If it was not already open, open it
      if (!isActive) {
        currentItem.classList.add('active');
        currentContent.style.display = 'block';
      }
    });
  });
});

  } catch(e) { console.error(e); }
})();
})();
